<template>
  <div>
    <!-- Modal -->
    <div class="modal fade" id="addQuoteRequestModal" ref="modalEle" tabindex="-1" role="dialog"
         aria-labelledby="modelTitleId" aria-hidden="true">
      <div class="modal-dialog modal-full-width" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Dodaj dokument</h5>
            <button type="button" class="close ms-auto" data-bs-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div class="modal-body pt-3">

            <!-- WYBRANE POZYCJE -->
            <div class="table-responsive"
                 style="border-bottom:1px solid #ddd; padding-bottom:20px">
              <div class="d-flex gap-3 mb-3 align-items-end">
                <div>
                  <label class="form-label fw-semibold mb-1">Typ dokumentu</label>
                  <select v-model="documentType" class="form-select form-select-sm w-auto" style="min-width: 160px">
                    <option v-for="opt in documentTypeOptions" :key="opt" :value="opt">{{ opt.toUpperCase() }}</option>
                  </select>
                </div>

                <div v-if="documentType == 'mm'">
                  <label class="form-label fw-semibold">Magazyn docelowy </label>
                  <div>
                    <select class="form-select form-select-sm w-auto"
                            v-model.number="globalWarehouseId"
                            @change="applyGlobalWarehouse">
                      <option :value="null" disabled>— wybierz magazyn —</option>
                      <option v-for="w in warehouses" :key="w.id" :value="w.id">
                        {{ w.short_name || w.name }}
                      </option>
                    </select>
                  </div>
                </div>

                <div class="d-flex flex-column justify-content-end">
                  <label class="form-label fw-semibold mb-1">&nbsp;</label>
                  <button type="button" class="btn btn-outline-secondary btn-sm" @click="refreshDocNumber"
                          :disabled="isGeneratingNumber">
                    Odśwież numer
                  </button>
                </div>
              </div>


              <h6 class="mt-1 mb-4">
                Wybrane pozycje będą przypisane do dokumentu:
                <b>{{ documentNumber ?? 'generowanie numeru...' }}</b>
              </h6>

              <div v-if="selectedArticles.length">
			  <div class="card mb-3">
  <div class="card-body">

    <h6 class="mb-3">
      Dane wspólne dla dokumentu
    </h6>

    <div class="row g-2">

      <div class="col-md-3">
        <label class="form-label">
          Opis ruchu
        </label>

        <input
          type="text"
          class="form-control form-control-sm"
          v-model="globalComment"
        >
      </div>

      <div class="col-md-3">
        <label class="form-label">
          Osoba zlecająca
        </label>

        <input
          type="text"
          class="form-control form-control-sm"
          v-model="globalWhoIssuing"
        >
      </div>

      <div class="col-md-3">
        <label class="form-label">
          Osoba otrzymująca
        </label>

        <input
          type="text"
          class="form-control form-control-sm"
          v-model="globalWhoReceiving"
        >
      </div>

      <div class="col-md-3">
        <label class="form-label">
          Cel
        </label>

        <input
          type="text"
          class="form-control form-control-sm"
          v-model="globalPurpose"
        >
      </div>

    </div>
  </div>
</div>
                <h5 class="mb-3">Lista wybranych artykułów</h5>

                <table class="table table-striped">
                  <thead>
                  <tr>
                    <th></th>
                    <th>#</th>
                    <th>Nr Katalogowy</th>
                    <th>Model</th>
                    <th>J.m.</th>
                    <th>Nazwa/Opis</th>
                    <th style="min-width:200px">Z magazynu</th>
                <!--    <th style="min-width:180px">Do magazynu</th> -->
                    <th>Ilość</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr v-for="article in selectedArticles" :key="article.id">
                    <td>
                      <button @click="removeFromSelectedArticles(article.id)" class="btn btn-outline-danger btn-xs">Usuń
                      </button>
                    </td>

                    <td>{{ article.id }}</td>
                    <td>{{ article.catalog_number }}</td>
                    <td>{{ article.model }}</td>
                    <td>{{ article.article_unit?.name }}</td>
                    <td>{{ article.description }}</td>

                    <!-- Z MAGAZYNU -->
                    <td>
                      <div v-if="sourceOptions(article).length">
                        <select class="form-select form-select-sm"
                                v-model.number="article.previous_warehouse_id">
                          <option :value="null" disabled>— wybierz magazyn —</option>
                          <option v-for="opt in sourceOptions(article)" :key="opt.article_warehouse_id"
                                  :value="opt.article_warehouse_id">
                            {{ opt.short_name }} ({{ opt.quantity }})
                          </option>
                        </select>
                      </div>
                      <div v-else class="text-muted">brak stanów</div>
                    </td>

                    <!-- DO MAGAZYNU 
                    <td>
                      <select class="form-select form-select-sm"
                              v-model.number="article.warehouse_id">
                        <option :value="null" disabled>— wybierz magazyn docelowy —</option>
                        <option v-for="w in warehouses" :key="w.id" :value="w.id">
                          {{ w.short_name || w.name || ('WH#' + w.id) }}
                        </option>
                      </select>
                    </td>
-->
                    <!-- ILOŚĆ + POLA OPISOWE -->
                    <td>
<input
  style="min-width:80px; max-width:150px"
  type="number"
  :step="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
  :min="isIntegerUnit(article.article_unit?.name) ? 1 : 0.01"
  :max="documentType !== 'pw' ? getAvailableQuantity(article) : null"
  v-model.number="article.quantity"
  @input="onQuantityInput(article)"
  @keydown="blockNonNumeric($event, article.article_unit?.name)"
  class="form-control form-control-sm"
/>
<input type="hidden" v-model="article.comment">
<input type="hidden" v-model="article.who_issuing">
<input type="hidden" v-model="article.who_receiving">
<input type="hidden" v-model="article.purpose">
</td>


                  </tr>
                  </tbody>
                </table>

<div class="mt-3">
  <button
    type="button"
    class="btn btn-primary"
    @click="submit"
    :disabled="!canSubmit || isSubmitting"
    v-if="canSubmit">
    Dodaj wybrane pozycje
  </button>

  <div v-else class="alert alert-warning">
    Nie można dodać wybranych artykułów – niektóre pozycje mają zerowy stan magazynowy, a dokument nie jest typu PW.
  </div>
</div>
              </div>
            </div>

            <!-- LISTA ARTYKUŁÓW -->
            <h5 class="pt-4 pb-2">Lista dostępnych artykułów</h5>

            <ejs-grid
                ref="addItemMovementGridRef"
                id="addItemMovementGrid"
                height="500px"
                :dataSource="articlesDataManager"
                :allowPaging="true"
                :allowSorting="true"
                :allowFiltering="true"
                :pageSettings="pageSettings"
                :editSettings="editSettings"
                :filterSettings="filterOptions"
                :toolbar="toolbar"
                :toolbarClick="onToolbarClick"
                :actionBegin="actionBegin"
                :actionComplete="actionComplete"
            >
              <e-columns>
                <e-column headerText="Dodaj" width="80" :template="'addTemplate'" textAlign="Center" :allowEditing="false"/>
                <e-column field="id" headerText="ID" width="100" :isPrimaryKey="true" :visible="false" :allowEditing="false"/>
                <e-column field="photos" headerText="Zdjęcia" width="150" :template="'imageTemplate'"
                          :allowFiltering="false" :allowSorting="false" type="string" :allowEditing="false"/>
                <e-column field="catalog_number" headerText="Nr katalogowy" type="string" :allowEditing="false"/>
                <e-column field="model" headerText="Model" type="string" :allowEditing="false"/>
                <e-column field="description" headerText="Nazwa/Opis" type="string" :allowEditing="false"/>
               <e-column field="article_unit.name" headerText="J.m." :visible="true" :allowEditing="false"/>
                <!-- dla uproszczenia pokazujemy samą quantity; źródło i tak jest w szczegółach -->
                <e-column field="available_items.quantity" headerText="Stany magazynowe" width="150"
                          format="N2" :filter="filterNumeric" type="string" :allowEditing="false"/>
                 <e-column field="link" headerText="Link" :defaultValue="null" type="string"
                          :filter="filterDefault" :template="'linkTemplate'" :allowEditing="false"/>
              </e-columns>

<template v-slot:addTemplate="{ data }">
  <button
    @click="addToSelected(data)"
    class="btn btn-xs btn-outline-primary"
    :disabled="documentType !== 'pw' && (!data.available_items?.quantity || data.available_items.quantity < 1)"
    :title="documentType !== 'pw' && (!data.available_items?.quantity || data.available_items.quantity < 1) 
      ? 'Brak dostępnych sztuk dla tego artykułu' 
      : ''"
  >
    <template v-if="!isArticleSelected(data.id)">
      Dodaj
    </template>
    <template v-else>
      Wybrano
    </template>
  </button>
</template>


              <template v-slot:linkTemplate="{ data }">
                <a class="link link-primary" target="_blank" rel="noopener noreferrer" :href="data.link">{{
                    data.link
                  }}</a>
              </template>

              <template v-slot:imageTemplate="{ data }">
                <div v-if="data.photos && data.photos.length">
                  <img :src="`/${data.photos[0].photo_path}`" alt="Zdjęcie"
                       style="max-height: 100px; max-width: 150px"/>
                </div>
              </template>
            </ejs-grid>

          </div>
        </div>
      </div>
    </div>
	
	<!-- MINI MODAL -->
<div class="modal fade"
     id="articleDetailsModal"
     ref="articleDetailsModalRef"
     tabindex="-1">

  <div class="modal-dialog">
    <div class="modal-content">

      <div class="modal-header">
        <h5 class="modal-title">
          Dodaj artykuł
        </h5>

        <button type="button"
                class="btn-close"
                data-bs-dismiss="modal">
        </button>
      </div>

	<div class="modal-body" v-if="editingArticle">
	  <div class="mb-3">
		<div>
		  <label class="form-label">Ilość</label>
		  <div class="input-group">
			<input
			  type="number"
			  class="form-control"
			  :min="isIntegerUnit(editingArticle.article_unit?.name) ? 1 : 0.01"
			  :step="isIntegerUnit(editingArticle.article_unit?.name) ? 1 : 0.01"
			  :max="documentType !== 'pw' ? getAvailableQuantity(editingArticle) : null"
			  v-model.number="editingArticle.quantity"
			  @input="onQuantityInput(editingArticle)"
			  @keydown="blockNonNumeric($event, editingArticle.article_unit?.name)"
			/>
			<span class="input-group-text">
			  {{ editingArticle.article_unit?.name || '-' }}
			</span>
		  </div>
		</div>
	  </div>
	</div>

      <div class="modal-footer">
        <button class="btn btn-secondary"
                data-bs-dismiss="modal">
          Anuluj
        </button>

        <button class="btn btn-primary"
                @click="saveArticleFromModal">
          Dodaj artykuł
        </button>
      </div>

    </div>
  </div>
</div>

  </div>
</template>

<script>
import axios from 'axios'
import {ref} from 'vue'
import {Modal} from 'bootstrap'
import {usePage} from '@inertiajs/vue3'
import {DatePickerComponent} from '@syncfusion/ej2-vue-calendars'
import {GridComponent, ColumnsDirective, ColumnDirective} from '@syncfusion/ej2-vue-grids'
import {DataManager, Predicate, Query, WebMethodAdaptor} from '@syncfusion/ej2-data'

export default {
  components: {
    'ejs-grid': GridComponent,
    'e-columns': ColumnsDirective,
    'e-column': ColumnDirective,
    'ejs-datepicker': DatePickerComponent,
  },

  props: {
    // jeśli potrzebujesz — np. do wysyłki POST na konkretny movement
    selectedMovement: {type: Object, default: null},
    // jeśli klonujesz pozycje
    selectedItemToClone: {type: Array, default: () => []},
  },

  data() {
    return {
      // grid
	  globalComment: '',
globalWhoIssuing: '',
globalWhoReceiving: '',
globalPurpose: '',

      articlesDataManager: [],
	  articleDetailsModal: null,
editingArticle: null,
      globalWarehouseId: null,
      _lastGlobalWarehouseId: null,
      pageSettings: {pageSize: 50, pageCount: 5, pageSizes: [10, 20, 50, 100, 200, 500, 1000]},
      filterOptions: {type: 'Menu', operator: 'contains'},
      filterDefault: {operator: 'contains', params: {minLength: 2}},
      filterNumeric: {operator: 'equal'},
      editSettings: {allowEditing: true, mode: 'Batch'},
      toolbar: [
        {text: 'Resetuj filtry', prefixIcon: 'e-reset', id: 'reset_filters'},
        {text: 'Lista artykułów', prefixIcon: 'e-table-of-content', id: 'articles_list'},
        {text: 'Search', prefixIcon: 'e-search', id: 'search', align: 'center'},
        {text: 'Odśwież', prefixIcon: 'e-refresh', id: 'refresh', align: 'right'},
      ],

      // modal
      modalObj: null,

      // model
      warehouses: [],
      selectedArticles: [],

      // dokument
      //documentType: 'pw',
      ///documentTypeOptions: ['mm', 'pw', 'wz', 'rw'],
	  documentType: 'mm',
      documentTypeOptions: ['mm', 'wz', 'rw'],

      documentNumber: null,
      isGeneratingNumber: false,

      // UI
      isSubmitting: false,
    }
  },

  mounted() {
    this.modalObj = new Modal(this.$refs.modalEle)

    this.initGrid()
    this.loadWarehouses()
    this.refreshDocNumber()

    // jeśli podany klon
    if (this.selectedItemToClone?.length) {
      this.addManyFromClone(this.selectedItemToClone)
    }
	this.articleDetailsModal = new Modal(
  this.$refs.articleDetailsModalRef
)
  },

watch: {
  documentType() {
    this.refreshDocNumber()
  },

  globalComment(val) {
    this.selectedArticles.forEach(a => {
      a.comment = val
    })
  },

  globalWhoIssuing(val) {
    this.selectedArticles.forEach(a => {
      a.who_issuing = val
    })
  },

  globalWhoReceiving(val) {
    this.selectedArticles.forEach(a => {
      a.who_receiving = val
    })
  },

  globalPurpose(val) {
    this.selectedArticles.forEach(a => {
      a.purpose = val
    })
  },
},
computed: {
  canSubmit() {
    // PW zawsze pozwala
    if (this.documentType === 'pw') return true

    // Inny dokument → sprawdź stany magazynowe
    return this.selectedArticles.every(
      a => a.available_items?.quantity > 0
    )
  },

  hasZeroQuantityArticles() {
    // true jeśli są artykuły ze stanem 0 lub pustym
    return this.selectedArticles.some(
      a => !a.available_items?.quantity || a.available_items.quantity <= 0
    )
  }
},

  methods: {
  getAvailableQuantity(article) {

  if (!article?.previous_warehouse_id) return 0

  const options = this.sourceOptions(article)

  const selectedWarehouse = options.find(
    x => Number(x.article_warehouse_id) === Number(article.previous_warehouse_id)
  )

  return Number(selectedWarehouse?.quantity || 0)
},
 // Sprawdza czy jednostka wymaga liczby całkowitej
  isIntegerUnit(unitName) {
    return unitName && ['szt', 'szt.', 'kpl'].includes(unitName.toLowerCase());
  },

  // Blokuje niecyfrowe znaki dla jednostek całkowitych
blockNonNumeric(event, unitName) {
  const allowedKeys = [
    'Backspace','ArrowLeft','ArrowRight','ArrowUp','ArrowDown','Delete','Tab'
  ];

  if (allowedKeys.includes(event.key)) return;

  if (this.isIntegerUnit(unitName)) {
    if (!/^\d$/.test(event.key)) event.preventDefault();
  } else {
    if (!/^[\d.,]$/.test(event.key)) event.preventDefault();
  }
},
  // Zaokrągla ilość jeśli jednostka całkowita
onQuantityInput(article) {

  if (article.quantity === null || article.quantity === '') return

  // INTEGER / FLOAT
  if (this.isIntegerUnit(article.article_unit?.name)) {

    article.quantity = Math.max(
      1,
      Math.floor(article.quantity || 1)
    )

  } else {

    let val = article.quantity

    if (typeof val === 'string') {
      val = val.replace(',', '.')
    }

    const parsed = parseFloat(val)

    article.quantity = isNaN(parsed)
      ? null
      : parsed
  }

  // LIMIT DLA INNYCH DOKUMENTÓW NIŻ PW
  if (this.documentType !== 'pw') {

    const maxQty = this.getAvailableQuantity(article)

    if (article.quantity > maxQty) {
      article.quantity = maxQty
    }
  }
},
  
    /* ───────────── Grid / Dane ───────────── */
    initGrid() {
      this.articlesDataManager = new DataManager({
        url: route('articles.get'),
        adaptor: new WebMethodAdaptor(),
        crossDomain: true,
        headers: [{'X-CSRF-TOKEN': usePage().props.csrf_token}],
      })
    },

    async loadWarehouses() {
      const resp = await axios.get(route('get.article-warehouses'))
      this.warehouses = Array.isArray(resp.data) ? resp.data : []

      // ustaw domyślnie docelowy magazyn dla już wybranych
      const firstId = this.warehouses?.[0]?.id ?? null
      if (firstId) {
        this.selectedArticles = this.selectedArticles.map(a => ({
          ...a,
          warehouse_id: a.warehouse_id ?? firstId,
        }))
      }
    },

    /* ───────────── Normalizacja pozycji ───────────── */
addToSelected(row) {

  if (this.isArticleSelected(row.id)) return

  this.editingArticle = this.normalizeRow(row)

  this.articleDetailsModal.show()
},
saveArticleFromModal() {

  if (!this.editingArticle) return

  this.selectedArticles.push({
    ...this.editingArticle
  })

  this.articleDetailsModal.hide()

  this.editingArticle = null
},

    addManyFromClone(list) {
      list.forEach((row) => {
        if (this.isArticleSelected(row.id)) return
        const item = this.normalizeRow(row)
        this.selectedArticles.push(item)
      })
    },

    normalizeRow(row) {
      // jeżeli przychodzi z relacją article — weź jej pola
      const src = row?.article ? row.article : row

      const item = {
        id: src?.id,
        catalog_number: src?.catalog_number || '',
        model: src?.model || '',
        description: src?.description || '',
        article_unit: src?.article_unit || (src?.unit_id ? {id: src.unit_id, name: '', allow_decimal: 0} : null),
        photos: src?.photos || [],
        available_items: row?.available_items || {}, // ← single object / array / dict

        quantity: 1,
comment: this.globalComment || '',
who_issuing: this.globalWhoIssuing || '',
who_receiving: this.globalWhoReceiving || '',
purpose: this.globalPurpose || '',

        previous_warehouse_id: null,
        warehouse_id: null,
      }

      // domyśl: jeśli jest dokładnie jeden magazyn ze stanem > 0 → wybierz go
      const options = this.optionsFromAvailable(item.available_items)
      if (options.length === 1) item.previous_warehouse_id = options[0].article_warehouse_id

      // docelowy magazyn domyślnie pierwszy dostępny
      if (this.globalWarehouseId) {
        item.warehouse_id = this.globalWarehouseId;
      } else {
        const firstId = this.warehouses?.[0]?.id ?? null;
        if (firstId) item.warehouse_id = firstId;
      }

      return item
    },

    // ustalanie targetowego magazynu z globalnego inputa
    applyGlobalWarehouse() {
      if (!this.globalWarehouseId) return;

      const last = this._lastGlobalWarehouseId;

      for (let i = 0; i < this.selectedArticles.length; i++) {
        const item = this.selectedArticles[i];
        const hasSource = this.sourceOptions(item).length > 0;

        // Brak stanów = zawsze ustaw globalny
        if (!hasSource) {
          this.selectedArticles[i].warehouse_id = this.globalWarehouseId;
          continue;
        }

        // Jeżeli nie zmienił ręcznie
        if (!item.warehouse_id || item.warehouse_id === last) {
          this.selectedArticles[i].warehouse_id = this.globalWarehouseId;
        }
      }

      this._lastGlobalWarehouseId = this.globalWarehouseId;
    },


    isArticleSelected(id) {
      return this.selectedArticles.some(a => a.id === id)
    },

    removeFromSelectedArticles(id) {
      this.selectedArticles = this.selectedArticles.filter(a => a.id !== id)
    },

    /* ───────────── Źródłowe magazyny (prosto) ───────────── */
    // weź listę {article_warehouse_id, quantity} niezależnie od formatu available_items
    extractAvailableList(avail) {
      const out = []

      if (!avail || typeof avail !== 'object') return out

      // 1) jeżeli tablica
      if (Array.isArray(avail)) {
        for (const x of avail) {
          const id = Number(x?.article_warehouse_id ?? x?.warehouse_id ?? x?.id ?? 0)
          const qty = Number(x?.quantity ?? 0)
          if (id && qty > 0) out.push({article_warehouse_id: id, quantity: qty})
        }
        return out
      }

      // 2) jeżeli płaski obiekt ze swoimi polami
      if ('article_warehouse_id' in avail || 'warehouse_id' in avail || 'id' in avail) {
        const id = Number(avail?.article_warehouse_id ?? avail?.warehouse_id ?? avail?.id ?? 0)
        const qty = Number(avail?.quantity ?? 0)
        if (id && qty > 0) out.push({article_warehouse_id: id, quantity: qty})
        return out
      }

      // 3) słownik -> weź wartości
      for (const v of Object.values(avail)) {
        if (!v || typeof v !== 'object') continue
        const id = Number(v?.article_warehouse_id ?? v?.warehouse_id ?? v?.id ?? 0)
        const qty = Number(v?.quantity ?? 0)
        if (id && qty > 0) out.push({article_warehouse_id: id, quantity: qty})
      }

      return out
    },

    optionsFromAvailable(avail) {
      const base = this.extractAvailableList(avail)
      return base.map(x => {
        const wh = this.warehouses.find(w => Number(w.id) === Number(x.article_warehouse_id))
        return {
          article_warehouse_id: x.article_warehouse_id,
          quantity: x.quantity,
          short_name: wh?.short_name ?? wh?.name ?? `Magazyn #${x.article_warehouse_id}`,
        }
      })
    },

    sourceOptions(article) {
      return this.optionsFromAvailable(article?.available_items)
    },

    /* ───────────── Numer dokumentu ───────────── */
    async refreshDocNumber() {
      this.documentNumber = null
      this.documentNumber = await this.generateDocumentNumber()
    },

    async generateDocumentNumber() {
      try {
        this.isGeneratingNumber = true
        const {data} = await axios.get(
            route('warehouse-movements.generate-document-number-json', {
              document_type: this.documentType ?? 'PW',
              order_list_item_id: null,
              oldWarehouse: null,
              newWarehouse: {id: 1, name: 'Główny'},
              fromQuoteRequest: false,
            })
        )
        return data?.number ?? null
      } catch (e) {
        console.error(e)
        return null
      } finally {
        this.isGeneratingNumber = false
      }
    },

    /* ───────────── Submit ───────────── */
    async submit() {
      if (!this.selectedArticles.length) {
        Toast?.fire?.({
          icon: 'warning',
          title: 'Brak pozycji',
          html: 'Najpierw dodaj co najmniej jeden artykuł.',
          toast: true,
          timer: 2500
        })
        return
      }

      // ilości
      const errors = []
      for (const a of this.selectedArticles) {
        const q = Number(a.quantity)
        if (!Number.isFinite(q) || q <= 0) errors.push(`Artykuł #${a.id}: ilość musi być > 0`)
        // jeśli są dostępne magazyny źródłowe, wymagaj wyboru
        if (this.sourceOptions(a).length && !a.previous_warehouse_id) {
          errors.push(`Artykuł #${a.id}: wybierz magazyn źródłowy`)
        }
        if (!a.warehouse_id) errors.push(`Artykuł #${a.id}: wybierz magazyn docelowy`)
      }
      if (errors.length) {
        Toast?.fire?.({icon: 'error', title: 'Błędne dane', html: errors.join('<br/>')})
        return
      }

      // numer dokumentu (jeśli brak — wygeneruj teraz)
      if (!this.documentNumber) this.documentNumber = await this.generateDocumentNumber()

      const payload = {
        document_number: this.documentNumber,
        items: this.selectedArticles.map(a => ({
          article_id: a.id,
          quantity: Number(a.quantity),
          comment: a.comment ?? '',
          who_issuing: a.who_issuing ?? '',
          who_receiving: a.who_receiving ?? '',
          purpose: a.purpose ?? '',
          additional_comment: this.selectedMovement?.additional_comment ?? '',
          previous_warehouse_id: a.previous_warehouse_id ?? null, // pojedyncze ID
          warehouse_id: a.warehouse_id ?? null,
        })),
      }

      this.isSubmitting = true
      try {
        const resp = await axios.post(
            route('warehouse-movements.add-item.store', {movement: this.selectedMovement?.id}),
            payload
        )

        Toast?.fire?.({
          icon: resp?.data?.icon || 'success',
          title: resp?.data?.title || 'Dodano pozycje',
          html: resp?.data?.message || 'Pozycje zostały dodane do ruchu.',
          timer: 2500,
        })

        this.selectedArticles = []
        this.$emit?.('added', resp?.data ?? null)
        this.hide()
      } catch (e) {
        const msg = e?.response?.data?.message || e?.message || 'Nie udało się dodać dokumentu.'
        Toast?.fire?.({icon: 'error', title: 'Błąd', html: msg})
        console.error(e)
      } finally {
        this.isSubmitting = false
      }
    },

    /* ───────────── Toolbar / Grid UX ───────────── */
    onToolbarClick(args) {
      if (args?.item?.id === 'reset_filters') {
        this.$refs.addItemMovementGridRef.clearFiltering()
      }
      if (args?.item?.id === 'articles_list') {
        window.open(route('articles.index'), '_blank')
      }
      if (args?.item?.id === 'refresh') {
        this.$refs.addItemMovementGridRef.ej2Instances.refresh()
      }
    },

    actionBegin(args) {
      // prosty multi-search po przecinku
      if (args.requestType === 'searching') {
        const keys = String(args.searchString || '').split(',').map(s => s.trim()).filter(Boolean)
        if (!keys.length) return
        let predicate = null
        const cols = this.$refs.addItemMovementGridRef.ej2Instances.getColumns()
        for (const key of keys) {
          for (const col of cols) {
            const p = new Predicate(col.field, 'contains', key, true)
            predicate = predicate ? predicate.or(p) : p
          }
        }
        this.$refs.addItemMovementGridRef.ej2Instances.query = new Query().where(predicate)
        this.$refs.addItemMovementGridRef.ej2Instances.searchSettings.key = ''
        this.$refs.addItemMovementGridRef.ej2Instances.refresh()
      }
    },

    actionComplete(args) {
      // brak specjalnej logiki — zostawiam szkielet
    },

    /* ───────────── Modal ───────────── */
    show() {
      this.modalObj?.show()
    },
    hide() {
      this.modalObj?.hide()
    },
  },
}
</script>
